import { Box, BoxProps, Text } from 'grommet';
import { ReactNode } from 'react';

export type LabeledFieldProps = BoxProps & {
  label: string;
  /** The id of the input the label names */
  htmlFor?: string;
  /** Something at the right of the label row, like a "Forgot?" link */
  action?: ReactNode;
  children: ReactNode;
};

/** A field with its small grey label above it, as in the session card and Project Home header */
export const LabeledField = ({ label, htmlFor, action, children, ...props }: LabeledFieldProps) => (
  <Box gap="4px" {...props}>
    <Box direction="row" justify="between" align="center">
      <label htmlFor={htmlFor}>
        <Text size="xsmall" color="text-label">
          {label}
        </Text>
      </label>
      {action}
    </Box>
    {children}
  </Box>
);
